import type { CountryServiceExtended } from '@stores/services/services.reducer';

import { createAction, props } from '@ngrx/store';

export const loadServicesSuccess = createAction(
  '[Services] Load services Success',
  props<{ service?: CountryServiceExtended }>()
);
